import { inject, Injectable } from '@angular/core';
import { CookieConsent } from 'src/app/_core/state/dialogs/cookies/service/models/cookie-consent';
import { LocaleService } from 'src/app/services/locale.service';

const COOKIE_CONSENT_KEY = 'cookie-consent';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  private readonly localeService = inject(LocaleService);

  hasCookies(): boolean {
    return !!localStorage.getItem(COOKIE_CONSENT_KEY);
  }

  setCookiesLocalStorage(cookies: CookieConsent[]) {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(cookies));
  }

  hasConsentForCookie(cookieId: string): boolean {
    const cookies = this.getCookies();
    return cookies.find((c) => c.id === cookieId)?.accepted;
  }

  getCookies(): CookieConsent[] {
    const cookiesStored = localStorage.getItem(COOKIE_CONSENT_KEY);
    const lang = this.localeService.getLanguage();
    let configuredCookies = [];

    if (cookiesStored) {
      configuredCookies = JSON.parse(cookiesStored);
    }

    return [
      {
        id: 'aws',
        required: true,
        accepted: configuredCookies.find((c) => c.id === 'aws')?.accepted ?? true,
        show: true,
        title: 'cookies.aws.title',
        description: 'cookies.aws.description',
      },
      {
        id: 'session',
        required: true,
        accepted: configuredCookies.find((c) => c.id === 'session')?.accepted ?? true,
        show: true,
        title: 'cookies.session.title',
        description: 'cookies.session.description',
      },
      {
        id: 'ga',
        required: false,
        accepted: configuredCookies.find((c) => c.id === 'ga')?.accepted ?? false,
        show: true,
        title: 'cookies.ga.title',
        description: 'cookies.ga.description',
      },
      {
        id: 'heap',
        required: false,
        accepted: configuredCookies.find((c) => c.id === 'heap')?.accepted ?? false,
        show: lang !== 'nl',
        title: 'cookies.heap.title',
        description: 'cookies.heap.description',
      },
      {
        id: 'zendesk',
        required: false,
        accepted: configuredCookies.find((c) => c.id === 'zendesk')?.accepted ?? false,
        show: true,
        title: 'cookies.zendesk.title',
        description: 'cookies.zendesk.description',
      },
      {
        id: 'clarity',
        required: false,
        accepted: configuredCookies.find((c) => c.id === 'clarity')?.accepted ?? false,
        show: true,
        title: 'cookies.clarity.title',
        description: 'cookies.clarity.description',
      },
      {
        id: 'amplitude',
        required: false,
        accepted: configuredCookies.find((c) => c.id === 'amplitude')?.accepted ?? false,
        show: true,
        title: 'cookies.amplitude.title',
        description: 'cookies.amplitude.description',
      },
    ];
  }
}
